import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';

import { IDictionary, IDictionaryCommon, IDictionaryContactDetails, IDictionaryList, IDictionaryContent, IDictionaryMessage, IDictionaryPlaceholderText, IInquiryType } from '../models/dictionary.model';

const sitecoreApiHost = environment.apiBaseUrl;


@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  private dictionaryCache: { [lang: string]: Observable<IDictionary> } = {};

  commonLabels: IDictionaryCommon = {} as IDictionaryCommon;
  contactDetailsLabels: IDictionaryContactDetails = {} as IDictionaryContactDetails;
  listLabels: IDictionaryList = {} as IDictionaryList;
  contentLabels: IDictionaryContent = {} as IDictionaryContent;
  messageLabels: IDictionaryMessage = {} as IDictionaryMessage;
  placeholderTextLabels: IDictionaryPlaceholderText = {} as IDictionaryPlaceholderText;

  constructor(private http: HttpClient) {}

  getProductCategories(Lang: string): Observable<any[]> {
    return this.http.get<any[]>(sitecoreApiHost+ '/HCCItemService/GetProductCategories?Lang=' + Lang);
  }

  getProducts(ItemID: string, Lang: string): Observable<any[]> {
    return this.http.get<any[]>(sitecoreApiHost+ '/HCCItemService/GetProducts?Guid=' + ItemID + '&Lang=' + Lang);
  }

  getDictionary(Lang: string): Observable<IDictionary> {
    if (!this.dictionaryCache[Lang]) {
      this.dictionaryCache[Lang] = this.http.get<IDictionary>(
        sitecoreApiHost + '/HCCItemService/GetDictionary?Guid={7609F348-0853-4A3E-94DB-183EFC010F79}&Lang=' + Lang).pipe(
        tap(data => {
          const form = data['contactUsForm'];
          const common = form.common;
          this.commonLabels = {
            countryAreaCode: common['countryAreaCode'],
            describeRequest: common['describeRequest'],
            inquiryType: common['inquiryType'],
            headDesc: common['headDesc'],
            nameOfPortal: common['nameOfPortal'],
            phone: common['phone'],
            policyNumber: common['policyNumber'],
            product: common['product'],
            question: common['question'],
            reason: common['reason'],
            productCategory: common['productCategory'],
            portalURL: common['portalURL'],
            userType: common['userType'],
            pleaseSpecify: common['pleaseSpecify']
          };
          const contact = form['contactDetails'];
          this.contactDetailsLabels = {
            company: contact['company'],
            confirmEmail: contact['confirmEmail'],
            country: contact['country'],
            emailAddress: contact['emailAddress'],
            firstName: contact['firstName'],
            header: contact['header'],
            lastName: contact['lastName'],
            preferredLanguage: contact['preferredLanguage'],
            terms: contact['terms'],
            submit: contact['submit']
          };
          const list = form['list'];
          this.listLabels = {
            inquiryType: list['inquiryType'],
            userType: list['userType'],
            portals: list['portals'],
            languages: list['languages']
          };
          const content = form['content'];
          this.contentLabels = {
            careers: content['careers'],
            employmentVeri: content['employmentVeri'],
            reportClaim: content['reportClaim'],
            requestLoss: content['requestLoss'],
            complaints: content['complaints']
          };
          const message = form['message'];
          this.messageLabels = {
            characterLimit: message['characterLimit'],
            loading: message['loading'],
            confirmEmail: message['confirmEmail'],
            emailNotMatch: message['emailNotMatch'],
            fieldRequired: message['fieldRequired'],
            thankYou: message['thankYou'],
            validEmail: message['validEmail'],
            validPhone: message['validPhone'],
            error: message['error'],
            validation: message['validation']
          };
          const placeholderText = form['placeholderText'];
          this.placeholderTextLabels = {
            confirmEmailAddress: placeholderText['confirmEmailAddress'],
            describeYourRequest: placeholderText['describeYourRequest'],
            enterPhoneNumber: placeholderText['enterPhoneNumber'],
            enterPolicyNumber: placeholderText['enterPolicyNumber'],
            enterYourCompanyName: placeholderText['enterYourCompanyName'],
            enterURL: placeholderText['enterURL'],
            enterYourFirstName: placeholderText['enterYourFirstName'],
            enterYourLastName: placeholderText['enterYourLastName'],
            enterYourQuestion: placeholderText['enterYourQuestion'],
            enterProductCat: placeholderText['enterProductCat'],
            enterProductName: placeholderText['enterProductName'],
            selectOption: placeholderText['selectOption'],
            selectPortal: placeholderText['selectPortal'],
            selectPreferredLang: placeholderText['selectPreferredLang'],
            selectProduct: placeholderText['selectProduct'],
            selectProductCat: placeholderText['selectProductCat'],
            selectUserType: placeholderText['selectUserType'],
            selectYourCountry: placeholderText['selectYourCountry'],
            other: placeholderText['other'],
            otherLang: placeholderText['otherLang']
          };
        }),
        shareReplay(1)
      );
    }
    return this.dictionaryCache[Lang];
  }

  submitContactForm(formData: any): Observable<any> {
    return this.http.post<any>(sitecoreApiHost + '/HCCItemService/PostContactusForm', formData);
  }

  
}
